import { createContext, useContext } from 'react';

import { createContextProvider } from '@rhino/shared/contexts/administration/SettingsHOC';

import {
  selectNebulonTileAttributes,
  updateNebulonTileSettingAsync,
  selectNebulonTileSputnikDeviceStatus,
  updateNebulonTileSputnikDeviceStatusAsync,
  selectNebulonRoomAttributes
} from '../../services/redux/nebulonSpreadSlice';

export type { AdminContextProps } from '@rhino/shared/types/admin';

const NebulonTileAttributesContext = createContext<AdminContextProps | undefined>(undefined);
export const NebulonTileAttributesProvider = createContextProvider({
    selectByName: selectNebulonTileAttributes,
    updateAsyncAction: updateNebulonTileSettingAsync,
    context: NebulonTileAttributesContext,
    updateObjectAdditionalParams: nebulonTileID => ({ nebulonTileID })
});
export const useNebulonTileAttributesContext = () => {
    const context = useContext(NebulonTileAttributesContext);
    if (!context) {
      throw new Error('useNebulonTileAttributesContext must be used within a NebulonTileAttributesContext');
    }
    return context;
};

const NebulonTileSputnikDeviceStatusContext = createContext<AdminContextProps | undefined>(undefined);
export const NebulonTileSputnikDeviceStatusProvider = createContextProvider({
    selectByName: selectNebulonTileSputnikDeviceStatus,
    updateAsyncAction: updateNebulonTileSputnikDeviceStatusAsync,
    context: NebulonTileSputnikDeviceStatusContext,
    updateObjectAdditionalParams: nebulonTileID => ({ nebulonTileID })
});
export const useNebulonTileSputnikDeviceStatusContext = () => {
    const context = useContext(NebulonTileSputnikDeviceStatusContext);
    if (!context) {
      throw new Error('useNebulonTileSputnikDeviceStatusContext must be used within a NebulonTileSputnikDeviceStatusContext');
    }
    return context;
};

const NebulonRoomAttributesContext = createContext<AdminContextProps | undefined>(undefined);
export const NebulonRoomAttributesProvider = createContextProvider({
    selectByName: selectNebulonRoomAttributes,
    updateAsyncAction: updateNebulonTileSettingAsync,
    context: NebulonRoomAttributesContext,
    updateObjectAdditionalParams: roomName => ({ isRoom: true, nebulonTileID: roomName })
});
export const useNebulonRoomAttributesContext = () => {
    const context = useContext(NebulonRoomAttributesContext);
    if (!context) {
      throw new Error('useNebulonRoomAttributesContext must be used within a NebulonRoomAttributesContext');
    }
    return context;
};

